import type { WithdrawalStatus } from '@shared/api/contracts';
import type { WithdrawalStatusVariant } from '../model/types';
import { isMerchantCancellableState, awaitsAdminApproval } from './state-view';

export const getWithdrawalStatusVariant = (status: WithdrawalStatus | string): WithdrawalStatusVariant => {
  switch (status) {
    case 'pending':
    case 'created':
    case 'approval_pending':
      return 'pending';
    case 'processing':
    case 'liquidity_provider_process':
    case 'approved':
    case 'signing':
    case 'broadcasted':
    case 'confirming':
      return 'processing';
    case 'success':
    case 'paid':
    case 'completed':
      return 'success';
    case 'cancel_by_user':
    case 'cancel_by_admin':
    case 'error':
    case 'rejected':
    case 'failed':
    case 'cancelled':
      return 'danger';
    case 'aml_pending':
    case 'manual_review':
    case 'blocked':
      return 'hold';
    case 'info_requested':
      return 'attention';
    default:
      return 'neutral';
  }
};

export const WITHDRAWAL_STATUS_VARIANT_CLASSES: Record<WithdrawalStatusVariant, string> = {
  pending: 'bg-pending text-pending-foreground',
  processing: 'bg-pending text-pending-foreground',
  success: 'bg-success text-success-foreground',
  info: 'bg-muted text-foreground',
  danger: 'bg-fail text-fail-foreground',
  neutral: 'bg-muted text-muted-foreground',
  hold: 'bg-pending text-pending-foreground',
  attention: 'bg-fail text-fail-foreground',
};

const LABELED_WITHDRAWAL_STATUSES = new Set<string>([
  'pending',
  'processing',
  'liquidity_provider_process',
  'success',
  'paid',
  'cancel_by_user',
  'cancel_by_admin',
  'error',
  'aml_pending',
  'manual_review',
  'info_requested',
]);

export const withdrawalStatusLabelKey = (status: string): string =>
  LABELED_WITHDRAWAL_STATUSES.has(status) ? `withdrawals.status.${status}` : 'withdrawals.status.unknown';

/** Отмена до начала исполнения. При известной стадии смотрим её, иначе legacy-статус. */
export const isWithdrawalCancellable = (status: WithdrawalStatus, state?: string | null): boolean =>
  isMerchantCancellableState(state, status);

/** Одобрение только пока заявка действительно ждёт решения администратора. */
export const isWithdrawalProcessable = (status: WithdrawalStatus, state?: string | null): boolean =>
  awaitsAdminApproval(state, status);
